export default __webpack_public_path__ + "svg/calendar/2026/4/junio.svg?108400e6";